import styled from 'styled-components';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  border-radius: ${props => props.theme.borderRadius};
  background-color: ${props => props.theme.backgroundColor};
  overflow: hidden;
`;

export const Title = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  transition: 0.2s all;
  padding: ${props => props.theme.padding.default};
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  line-height: ${props => props.theme.lineHeight};
  background-color: ${props => props.theme.backgroundColor};
`;

export const Image = styled.img`
  display: block;
  max-height: 65px;
  object-fit: contain;
  margin: ${props => props.theme.margin.default};
`;

export const Item = styled.div`
  width: 100%;
`;

export const Date = styled.div`
  width: 100%;
  text-align: center;
  margin: ${props => props.theme.margin.default};
  padding: ${props => props.theme.padding.default};
  background-color: ${props => props.theme.backgroundColor};
  border-bottom-left-radius: ${props => props.theme.borderRadius};
  border-bottom-right-radius: ${props => props.theme.borderRadius};
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  line-height: ${props => props.theme.lineHeight};
`;

export const MealsBox = styled.div`
  width: 100%;
  padding: ${props => props.theme.padding.default};
`;

export const Meal = styled.div`
  padding: ${props => props.theme.padding.default};
  margin: ${props => props.theme.margin.default};
  border-bottom: ${props => props.theme.border};

  &:last-child {
    margin: 0;
    padding: 0;
    border: none;
  }
`;

export const InnerTitle = styled.div`
  margin: ${props => props.theme.margin.default};
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  line-height: ${props => props.theme.lineHeight};
`;

export const Content = styled.pre`
  white-space: pre-line;
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  line-height: ${props => props.theme.lineHeight};
  background-color: transparent;
`;

export const Footer = styled.div`
  margin-top: auto;
  position: relative;
  padding: ${props => props.theme.padding.default};
  background-color: ${props => props.theme.backgroundColor};
`;

export const Decoration = styled.div`
  position: absolute;
  top: 50%;
  right: 29px;
  transform: translateY(-50%);
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  font-weight: ${props => props.theme.fontWeight};
  line-height: ${props => props.theme.lineHeight};
`;

export const NextArrow = styled.div`
  display: block;
  position: absolute;
  top: -23px;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  outline: none;
  z-index: 1;
  right: ${props => props.theme.offset};
  width: ${props => `${props.theme.size}px`};
  height: ${props => `${props.theme.size}px`};
  filter: ${props => props.theme.filterShadow};
  background-color: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize}rem`};
  & > svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 20px;
  }
  &:hover > svg {
    opacity: 0.75;
  }
`;

export const PrevArrow = styled.div`
  display: block;
  position: absolute;
  top: -23px;
  border-radius: 50%;
  cursor: pointer;
  border: none;
  outline: none;
  z-index: 1;
  left: ${props => props.theme.offset};
  width: ${props => `${props.theme.size}px`};
  height: ${props => `${props.theme.size}px`};
  filter: ${props => props.theme.filterShadow};
  background-color: ${props => props.theme.backgroundColor};
  color: ${props => props.theme.color};
  font-size: ${props => `${props.theme.fontSize}rem`};
  & > svg {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 20px;
  }
  &:hover > svg {
    opacity: 0.75;
  }
`;
